import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Action } from '@ngrx/store';
import { changePassword, requestError, requestSuccess } from './actions';
import {
  ChangePasswordInterface,
  ResponseLoginInterface,
} from '../../interfaces/auth.interface';

import { CookieCustomService } from '../../services/cookie.custom.service';

@Injectable()
export class ChangePasswordEffect {
  constructor(
    private service: AuthService,
    private actions$: Actions,
    private cookieService: CookieCustomService
  ) {}

  public changePassword$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(changePassword),

      switchMap((payload: { params: ChangePasswordInterface }) =>
        this.service.changePassword(payload.params).pipe(
          map((response: ResponseLoginInterface) => {
            if (response.errorCode.code !== 0) {
              throw response;
            }
            this.cookieService.updateAuthCookie(response);

            return requestSuccess({ response: response.response });
          }),
          catchError((error: ResponseLoginInterface) => {
            return of(requestError({ error: error.errorCode }));
          })
        )
      )
    );
  });
}
